import actionTypes from '../action-types';

export const setSortingFunction = (sortingFunction) => ({
  type: actionTypes.SET_SORTING_FUNCTION,
  sortingFunction,
});


// WEBPACK FOOTER //
// ./src/modules/utils/actions/table-sorting/table-sorting.actions.js